export function IncludedBadge() {
  return (
    <div className="rounded-full border border-green-500/30 bg-green-500/10 px-2 py-0.5 text-[10px] font-medium text-green-600 dark:text-green-400">
      Included
    </div>
  );
}
